<template>
  <div
    class="app-container"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="loading"
    infinite-scroll-distance="10"
  >
    <div class="app-content">
      <page-swipe
        @searchClick="handleSearch"
        :swipe-items="swipeItems"
        @swipeClick="handleSwipeClick"
      ></page-swipe>
      <category-cards
        @cateringBusinessClick="handleCateringBusinessClick"
        :catering-business-url="cateringBusinessUrl"
        @onlickSelectionClick="handleOnlineSelectionClick"
      ></category-cards>
      <div class="title">为你推荐</div>
    </div>
    <online-selection></online-selection>
  </div>
</template>
<script>
import { InfiniteScroll } from "mint-ui";
import { pageSwipe, categoryCards } from "./components";
import onlineSelection from "./onlineSelection";
import { Toast } from "mint-ui";
import {
  fetchRecommendations,
  fetchAdvertisementConfig
} from "../../common/api/delicacy";
import JSBridge from "../../jsbridge";
const ADCODE = "utopa_superfood_banner";
export default {
  name: "delicacy",
  directives: { InfiniteScroll },
  components: {
    pageSwipe,
    categoryCards,
    onlineSelection
  },
  data() {
    return {
      categoryNo: this.$route.query.categoryNo,
      swipeItems: [], // 轮播图
      toNative: true,
      cateringBusinessUrl: `${this.formatHref("cateringbusiness")}?categoryNo=${
        this.$route.query.categoryNo
      }`,
      recommendationsTotal: 0,
      recommendationsPageSize: 20,
      recommendationsPageNo: 0,
      recommendations: [],
      loading: false,
      loadingText: "正在加载更多...",
      finished: false,
      finishedText: "暂无更多内容",
      host: ""
    };
  },
  created() {
    this.fetchRecommendations();
    this.fetchAdvertisementConfig();
  },
  methods: {
    formatHref(hash) {
      this.host = location.href.split("/#/")[0];
      return `${this.host}/#/${hash}`;
    },
    handleSwipeClick(item) {
      if (item.command.url) {
        this.$router.push({ path: item.command.url });
      } else {
        let params = item.command;
        JSBridge.Common.Caller_Common_Base_cmd(params, () => {});
      }
    },
    handleSearch() {
      let code = "C0000012001";
      let params = {
        cmd: code,
        params: JSON.stringify({ categoryId: this.categoryNo })
      };
      JSBridge.Common.Caller_Common_Base_cmd(params, () => {});
    },
    handleCateringBusinessClick(url) {
      let params = {
        url: url
      };
      JSBridge.Common.Caller_Common_Base_cmd(params, () => {});
    },
    handleOnlineSelectionClick() {
      window.location.href = `${this.host}/m/liber/h5/#/mall?businessId=${
        this.$route.query.businessId
      }`;
    },
    handleCellClick(cell) {
      let params = {
        url: cell.magazineDetailUrl
      };
      JSBridge.Common.Caller_Common_Base_cmd(params, () => {});
    },
    fetchAdvertisementConfig() {
      let params = {
        code: ADCODE
      };
      fetchAdvertisementConfig(params)
        .then(res => {
          let resData = res.data;
          if (resData.code === 0) {
            this.swipeItems = resData.data.items;
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    fetchRecommendations() {
      this.finished = false;
      this.loading = true;
      let params = {
        pageNo: this.recommendationsPageNo + 1,
        pageSize: this.recommendationsPageSize
      };
      fetchRecommendations(params)
        .then(res => {
          let resData = res.data;
          if (resData.code === 0) {
            if (resData.data.records.length === 0) {
              this.loading = false;
              this.finished = true;
              return;
            }
            this.pageNo++;
            this.recommendationsTotal = resData.data.total;
            this.recommendations = this.recommendations.concat(
              resData.data.records
            );
          } else {
            Toast(res.msg);
          }
        })
        .catch(err => {
          Toast(err);
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
            if (this.recommendations.length >= this.recommendationsTotal) {
              this.finished = true;
            }
          });
        });
    },
    loadMore() {
      if (this.loading || this.finished) return;
      this.recommendationsPageNo++;
      this.fetchRecommendations();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/px2rem.scss";
@import "../../assets/css/colors.scss";
.app-container {
  background-color: $bgColor;
  .app-content {
    background-color: white;
  }
}
.title {
  font-size: px2rem(20);
  line-height: px2rem(25);
  text-align: center;
  padding: px2rem(20);
  color: $black;
}
.page-infinite-loading {
  text-align: center;
  padding: px2rem(30) 0;
  line-height: px2rem(20);
  font-size: px2rem(12);
  color: $gray;
}
</style>


